import createMaintenanceService from "./createMaintenanceService";

export default createMaintenanceService("/role");
